/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 94095:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(9366);

/***/ }),

/***/ 43226:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(90029)["default"]);
var React = __webpack_require__(16689);
var _require = __webpack_require__(31901),
  LandingContext = _require.LandingContext;
var NordicImage = __webpack_require__(29887);
var _require2 = __webpack_require__(35324),
  generateUrl = _require2.generateUrl;
var Image = function Image(_ref) {
  var image = _ref.image,
    alt = _ref.alt,
    _ref$lazyLoad = _ref.lazyLoad,
    lazyLoad = _ref$lazyLoad === void 0 ? true : _ref$lazyLoad,
    styles = _ref.styles,
    imgconfig = _ref.imgconfig,
    _ref$customClass = _ref.customClass,
    customClass = _ref$customClass === void 0 ? '' : _ref$customClass,
    _ref$mounted = _ref.mounted,
    mounted = _ref$mounted === void 0 ? false : _ref$mounted,
    _ref$carousel = _ref.carousel,
    carousel = _ref$carousel === void 0 ? false : _ref$carousel,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? undefined : _ref$onClick,
    _ref$forceURLCheck = _ref.forceURLCheck,
    forceURLCheck = _ref$forceURLCheck === void 0 ? undefined : _ref$forceURLCheck,
    _ref$preloadable = _ref.preloadable,
    preloadable = _ref$preloadable === void 0 ? false : _ref$preloadable;
  var _React$useContext = React.useContext(LandingContext),
    webp = _React$useContext.webp,
    lowEnd = _React$useContext.lowEnd,
    enabled = _React$useContext.lazyLoad.enabled,
    dpr = _React$useContext.dpr;
  var lazy = enabled && lazyLoad && !lowEnd && !mounted && !carousel;
  var src = generateUrl(dpr, webp, imgconfig, image, forceURLCheck);
  var width = styles && styles.width ? styles.width : undefined;
  return /*#__PURE__*/_jsx(NordicImage, {
    src: src,
    alt: alt,
    className: customClass,
    lazyload: lazy && !preloadable ? 'on' : 'off',
    width: width,
    onClick: onClick,
    preload: preloadable
  });
};
Image.defaultProps = {
  alt: '',
  lazyLoad: true,
  styles: null,
  imgconfig: {
    size: 'N',
    prefix: 'D_NQ_NP_'
  },
  customClass: '',
  mounted: false,
  carousel: false,
  onClick: undefined,
  forceURLCheck: false,
  preloadable: false
};
module.exports = Image;

/***/ }),

/***/ 9366:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Image = __webpack_require__(43226);
module.exports = Image;

/***/ }),

/***/ 35324:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(33114);
__webpack_require__(65562);
__webpack_require__(83790);
__webpack_require__(65347);
__webpack_require__(61000);
__webpack_require__(3524);
__webpack_require__(63317);
__webpack_require__(59344);
var imageHost = 'https://http2.mlstatic.com/';
var generateUrl = function generateUrl(dpr, webp, imgconfig, image, forceURLCheck) {
  var isFromStorage = image.match(/(mercadolibre|static\/org-img|optimize|resources)/);
  var isFromS3 = image.match(/storage\/splinter-admin/);
  // matches only for Pictures API with full url
  var hasFullUrl = image.match(/mlstatic/) && !isFromStorage && !isFromS3;
  // matches only when image param is an image id
  // TODO: Main Slider (Placement) recieve from Merch Engine an image id instead of a full URL.
  // We must build that full URL (pictures) programmatically
  var isAnImgId = !image.match(/mlstatic/) && !isFromStorage && !isFromS3;
  var shouldChangeURL = forceURLCheck && (hasFullUrl || isAnImgId);
  var imgName = image.replace(/^http:\/\//i, 'https://');
  if (isFromStorage && !shouldChangeURL) {
    return imgName;
  }
  if (isFromS3 && !shouldChangeURL) {
    var webpParam = webp ? '/o:f_webp' : '/o:f_jpg';
    var sizeParam = ",".concat(imgconfig.size);
    return imgName.replace('splinter-admin', "splinter-admin".concat(webpParam).concat(sizeParam));
  }
  // TODO: some components use full URL from admin, maybe we should change their signature to avoid doing this
  // regex:
  // - matches D, Q, N, P and underscores (from 2 up to 8 together) before any number (removes img prefix)
  // - all letters, - and . at the end of string (removes preset size and format)
  if (hasFullUrl) {
    imgName = image.replace(imageHost, '');
    // TODO: check all possible prefixes
    var matches = imgName.match(/([DQNP_]{2,8}(?!=[0-9])|[-.a-zA-Z]{6,7}$)/g) || [];
    imgName = matches.reduce(function (name, match) {
      return name.replace(match, '');
    }, imgName);
  }
  var format = webp ? 'webp' : 'jpg';
  var densityTag = (dpr !== null && dpr !== void 0 ? dpr : 1) > 1 ? '2X_' : '';
  if (shouldChangeURL) {
    var imgConfig = {
      size: 'OO',
      prefix: isAnImgId ? 'D_NQ_' : 'D_NQ_NP_'
    };
    return "".concat(imageHost).concat(imgConfig.prefix).concat(densityTag).concat(imgName, "-").concat(imgConfig.size, ".").concat(format);
  }
  return "".concat(imageHost).concat(imgconfig.prefix).concat(densityTag).concat(imgName, "-").concat(imgconfig.size, ".").concat(format);
};
module.exports = {
  generateUrl: generateUrl
};

/***/ }),

/***/ 90029:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/jsx");

/***/ }),

/***/ 31901:
/***/ ((module) => {

"use strict";
module.exports = require("@splinter/context");

/***/ }),

/***/ 33114:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.array.concat.js");

/***/ }),

/***/ 65562:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.array.reduce.js");

/***/ }),

/***/ 83790:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.iterator.constructor.js");

/***/ }),

/***/ 65347:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.iterator.reduce.js");

/***/ }),

/***/ 61000:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.object.to-string.js");

/***/ }),

/***/ 3524:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.regexp.exec.js");

/***/ }),

/***/ 63317:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.string.match.js");

/***/ }),

/***/ 59344:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.string.replace.js");

/***/ }),

/***/ 29887:
/***/ ((module) => {

"use strict";
module.exports = require("frontend-image");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module used 'module' so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(94095);
/******/ 	module.exports = __webpack_exports__;
/******/ 	
/******/ })()
;
//# sourceMappingURL=index.production.js.map